
import { add, FSharpMap__get_Item, tryFind, find } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { insertAt, filter, findIndex, length, getSlice, ofArray, empty, singleton, item, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { DrawModelType_SymbolT_symbolOf_, DrawModelType_SymbolT_movingPort_, DrawModelType_SymbolT_movingPortTarget_, DrawModelType_SymbolT_Symbol, DrawModelType_SymbolT_PortMaps, DrawModelType_SymbolT_ShowPorts, DrawModelType_SymbolT_appearance_, DrawModelType_SymbolT_showPorts_ } from "../Model/DrawModelType.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { $007CIsBinaryGate$007CNotBinaryGate$007C, Edge, XYPos } from "../Common/CommonTypes.js";
import { min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { getPortPos, getMuxSelOffset, autoScaleHAndW, Constants_portPosEdgeGap, Constants_gatePortPosEdgeGap } from "./Symbol.js";
import { equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

/**
 * Helper function to find which ports were deleted when changing Adder & Counter component type via properties
 */
export function findDeletedPorts(symModel, compId, oldComp, newComp) {
    const symbol = find(compId, symModel.Symbols);
    const oldCompType = oldComp.Type;
    return map((x_3) => tryFind(x_3, symModel.Ports), (oldCompType.tag === 17) ? ((newComp.tag === 18) ? singleton(item(0, symbol.Component.InputPorts).Id) : ((newComp.tag === 19) ? singleton(item(1, symbol.Component.OutputPorts).Id) : empty())) : ((oldCompType.tag === 19) ? ((newComp.tag === 20) ? singleton(item(0, symbol.Component.InputPorts).Id) : empty()) : ((oldCompType.tag === 18) ? ((newComp.tag === 20) ? singleton(item(1, symbol.Component.OutputPorts).Id) : empty()) : ((oldCompType.tag === 35) ? ((newComp.tag === 36) ? ofArray([item(0, symbol.Component.InputPorts).Id, item(1, symbol.Component.InputPorts).Id]) : ((newComp.tag === 37) ? singleton(item(2, symbol.Component.InputPorts).Id) : empty())) : ((oldCompType.tag === 37) ? ((newComp.tag === 38) ? ofArray([item(0, symbol.Component.InputPorts).Id, item(1, symbol.Component.InputPorts).Id]) : empty()) : ((oldCompType.tag === 36) ? ((newComp.tag === 38) ? singleton(item(0, symbol.Component.InputPorts).Id) : empty()) : ((oldCompType.tag === 10) ? ((newComp.tag === 10) ? ((newComp.fields[1] < oldCompType.fields[1]) ? map((x) => x.Id, getSlice(newComp.fields[1], undefined, symbol.Component.InputPorts)) : empty()) : empty()) : ((oldCompType.tag === 29) ? ((newComp.tag === 29) ? ((newComp.fields[0] < oldCompType.fields[0]) ? map((x_1) => x_1.Id, getSlice(newComp.fields[0], undefined, symbol.Component.InputPorts)) : empty()) : empty()) : ((oldCompType.tag === 30) ? ((newComp.tag === 30) ? ((newComp.fields[0] < oldCompType.fields[0]) ? map((x_2) => x_2.Id, getSlice(newComp.fields[0], undefined, symbol.Component.OutputPorts)) : empty()) : empty()) : empty())))))))));
}

export function showSymbolInPorts(_arg, sym) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowPorts.ShowInput)(sym);
}

export function showSymbolOutPorts(_arg, sym) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowPorts.ShowOutput)(sym);
}

export function showSymbolBothForPortMovementPorts(_arg, sym) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowPorts.ShowBothForPortMovement)(sym);
}

export function hideSymbolPorts(_arg, sym) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowPorts.ShowNone)(sym);
}

export function showSymbolPorts(sym) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowPorts.ShowBoth)(sym);
}

export function moveCustomPortsPopup() {
    let props_38, children_34, children_4, s_3, children_8, s_5, children_22, props_24, children_20, children_10, children_32, props_34, children_30, children_24;
    const bSpan = (txt_1) => {
        const props = [["style", {
            fontWeight: "bold",
        }]];
        return react.createElement("span", keyValueList(props, 1), txt_1);
    };
    const children_36 = [bSpan("Ports"), react.createElement("span", {}, " are the inputs and outputs of a component symbol."), react.createElement("br", {}), react.createElement("br", {}), (props_38 = [["style", {
        listStyle: "disc",
        marginLeft: "30px",
    }]], (children_34 = [(children_4 = [(s_3 = "Normal components can be rotated and flipped to change port orientation, however port positions cannot be changed.", s_3)], react.createElement("li", {}, ...children_4)), react.createElement("li", {}, "2-input MUX components can have 0 & 1 inputs swapped using properties."), (children_8 = [(s_5 = "Custom components (sheets inserted as components) can have ports moved to any side of the symbol and reordered.", s_5)], react.createElement("li", {}, ...children_8)), (children_22 = ["To move custom component ports:", (props_24 = [["style", {
        listStyle: "circle",
        marginLeft: "30px",
    }]], (children_20 = [(children_10 = ["Right-click the component and choose ", bSpan("Move ports"), ". Its draggable ports turn blue."], react.createElement("li", {}, ...children_10)), react.createElement("li", {}, "Drag a port to another position on the outline of the symbol."), react.createElement("li", {}, "You can reorder ports and place them on any symbol edge including top and bottom."), react.createElement("li", {}, "The symbol will resize itself if you change the edge of a port."), react.createElement("li", {}, "Click anywhere off the component when you have finished.")], react.createElement("ul", keyValueList(props_24, 1), ...children_20)))], react.createElement("li", {}, ...children_22)), (children_32 = ["To resize a custom component, when default sizing makes port legends overlap:", (props_34 = [["style", {
        listStyle: "circle",
        marginLeft: "30px",
    }]], (children_30 = [(children_24 = ["Right-click the component and choose ", bSpan("Resize symbol"), ". Blue handles appear on its corners."], react.createElement("li", {}, ...children_24)), react.createElement("li", {}, "Drag any corner to scale the symbol."), react.createElement("li", {}, "Click anywhere off the component when you have finished.")], react.createElement("ul", keyValueList(props_34, 1), ...children_30)))], react.createElement("li", {}, ...children_32))], react.createElement("ul", keyValueList(props_38, 1), ...children_34)))];
    return react.createElement("div", {}, ...children_36);
}

/**
 * Returns an Option Edge. Returns Some edge if position is on edge of Symbol, and None if it was not on an edge
 * Separates the symbol as shown below where the two triangles have height = 0.3*symbolHeight
 */
export function getCloseByEdge(sym, mousePos) {
    let patternInput_1;
    const sym_1 = sym;
    const comp = sym_1.Component;
    const matchValue = defaultArg(sym_1.HScale, 1);
    const vS = defaultArg(sym_1.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym_1.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput_1 = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput_1 = [comp.H * vS, comp.W * hS];
    }
    const w = patternInput_1[1];
    const h = patternInput_1[0];
    const triangleCorner = new XYPos(w / 2, h * 0.3);
    const tanTheta = triangleCorner.Y / triangleCorner.X;
    let mouseOffset;
    const left = mousePos;
    const right = sym.Pos;
    mouseOffset = (new XYPos(left.X - right.X, left.Y - right.Y));
    const minX = min(Math.abs(mouseOffset.X), Math.abs(w) - mouseOffset.X);
    if ((((-60 <= mouseOffset.Y) && (mouseOffset.Y <= (minX * tanTheta))) && (-60 <= mouseOffset.X)) && ((w + 60) >= mouseOffset.X)) {
        return Edge.Top;
    }
    else if (((((h + 60) >= mouseOffset.Y) && (mouseOffset.Y >= (h - (minX * tanTheta)))) && (-60 <= mouseOffset.X)) && ((w + 60) >= mouseOffset.X)) {
        return Edge.Bottom;
    }
    else if ((((-60 >= mouseOffset.Y) ? true : ((h + 60) <= mouseOffset.Y)) ? true : (-60 >= mouseOffset.X)) ? true : ((w + 60) <= mouseOffset.X)) {
        return undefined;
    }
    else if ((-60 <= mouseOffset.X) && (mouseOffset.X <= (w / 2))) {
        return Edge.Left;
    }
    else if (((w + 60) >= mouseOffset.X) && (mouseOffset.X > (w / 2))) {
        return Edge.Right;
    }
    else {
        return undefined;
    }
}

/**
 * Given a symbol and a port, it returns the offset of the port from the top left corner of the symbol
 */
export function getPosIndex(sym, pos, edge) {
    const ports = FSharpMap__get_Item(sym.PortMaps.Order, edge);
    let gap;
    const ct = sym.Component.Type;
    let matchResult;
    switch (ct.tag) {
        case 27:
        case 28: {
            matchResult = 0;
            break;
        }
        case 11: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 29: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 30: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
    }
    switch (matchResult) {
        case 0: {
            gap = 0.25;
            break;
        }
        case 1: {
            gap = Constants_gatePortPosEdgeGap;
            break;
        }
        default:
            gap = Constants_portPosEdgeGap;
    }
    let pos$0027;
    let left_1;
    const left = pos;
    const right = sym.Pos;
    left_1 = (new XYPos(left.X - right.X, left.Y - right.Y));
    let right_1;
    const side = edge;
    let patternInput;
    const sym_2 = sym;
    const comp = sym_2.Component;
    const matchValue = defaultArg(sym_2.HScale, 1);
    const vS = defaultArg(sym_2.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym_2.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput = [comp.H * vS, comp.W * hS];
    }
    right_1 = ((side.tag === 2) ? (new XYPos(0, 0)) : ((side.tag === 0) ? (new XYPos(0, 0)) : ((side.tag === 1) ? (new XYPos(0, patternInput[0])) : (new XYPos(patternInput[1], 0)))));
    pos$0027 = (new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y));
    let patternInput_3;
    const sym_3 = sym;
    const comp_1 = sym_3.Component;
    const matchValue_3 = defaultArg(sym_3.HScale, 1);
    const vS_1 = defaultArg(sym_3.VScale, 1);
    const hS_1 = matchValue_3;
    const matchValue_2_1 = sym_3.STransform.Rotation;
    switch (matchValue_2_1.tag) {
        case 1:
        case 3: {
            patternInput_3 = [comp_1.W * hS_1, comp_1.H * vS_1];
            break;
        }
        default:
            patternInput_3 = [comp_1.H * vS_1, comp_1.W * hS_1];
    }
    const w_1 = patternInput_3[1];
    const h_1 = patternInput_3[0];
    const matchValue_4 = length(ports) | 0;
    if (matchValue_4 === 0) {
        return 0;
    }
    else {
        switch (edge.tag) {
            case 3:
                return (-1 * ~~((((((pos$0027.Y * (((length(ports) + 1) + (2 * gap)) - 1)) / h_1) + 1) - gap) - (length(ports) + 1)) - 0.5)) | 0;
            case 1:
                return ~~((((pos$0027.X * (((length(ports) + 1) + (2 * gap)) - 1)) / w_1) - gap) + 0.5) | 0;
            case 0:
                return (-1 * ~~((((((pos$0027.X * (((length(ports) + 1) + (2 * gap)) - 1)) / w_1) - (length(ports) + 1)) + 1) - gap) - 0.5)) | 0;
            default:
                return ~~((((pos$0027.Y * (((length(ports) + 1) + (2 * gap)) - 1)) / h_1) - gap) + 0.5) | 0;
        }
    }
}

export function updatePortPos(sym, pos, portId) {
    if (sym.Component.Type.tag === 26) {
        const oldMaps = sym.PortMaps;
        const matchValue_1 = getCloseByEdge(sym, pos);
        if (matchValue_1 != null) {
            const edge = matchValue_1;
            const newPortOrientation = add(portId, edge, oldMaps.Orientation);
            const oldEdge = FSharpMap__get_Item(oldMaps.Orientation, portId);
            const newPortIdx = getPosIndex(sym, pos, edge) | 0;
            const oldIdx = findIndex((el) => equals(el, portId), FSharpMap__get_Item(oldMaps.Order, oldEdge)) | 0;
            const oldPortOrder$0027 = add(oldEdge, filter((el_1) => !equals(el_1, portId), FSharpMap__get_Item(oldMaps.Order, oldEdge)), oldMaps.Order);
            return autoScaleHAndW(new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, new DrawModelType_SymbolT_PortMaps(add(edge, insertAt((newPortIdx > length(FSharpMap__get_Item(oldPortOrder$0027, edge))) ? length(FSharpMap__get_Item(oldPortOrder$0027, edge)) : ((equals(edge, oldEdge) && (oldIdx < newPortIdx)) ? (newPortIdx - 1) : newPortIdx), portId, FSharpMap__get_Item(oldPortOrder$0027, edge)), oldPortOrder$0027), newPortOrientation), sym.HScale, sym.VScale, undefined, sym.MovingPortTarget, sym.ArrayText));
        }
        else {
            return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, undefined, sym.MovingPortTarget, sym.ArrayText);
        }
    }
    else {
        return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, undefined, sym.MovingPortTarget, sym.ArrayText);
    }
}

/**
 * Contains the code for the MovePort update msg
 */
export function movePortUpdate(model, portId, pos) {
    let port, symbol_2, tempSymbol, oldEdge, oldOrder, newEdge, newOrder, newPortPos, x, sym_7, comp_5, matchValue_8, vS_5, hS_5, matchValue_2_5, y, sym_8, comp_6, matchValue_9, vS_6, hS_6, matchValue_2_6, diff, symbol, edge, portsOnEdge, offset, symbol_1, edge_1, order, portsOnEdge_1, sym_4, comp_2, matchValue_4, vS_2, hS_2, matchValue_2_2, sym_5, comp_3, matchValue_5, vS_3, hS_3, matchValue_2_3, patternInput_7, sym_6, comp_4, matchValue_6, vS_4, hS_4, matchValue_2_4, firstPortPos, lastPortPos, firstPortXorY, lastPortXorY, hORw, value_4, value;
    const getPortPosWithIndex = (sym, portsNumber, side, portIndex) => {
        const index = portIndex;
        let gap;
        const ct = sym.Component.Type;
        let matchResult;
        switch (ct.tag) {
            case 27:
            case 28: {
                matchResult = 0;
                break;
            }
            case 11: {
                if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            case 29: {
                if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            case 30: {
                if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            default:
                if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
        }
        switch (matchResult) {
            case 0: {
                gap = 0.25;
                break;
            }
            case 1: {
                gap = Constants_gatePortPosEdgeGap;
                break;
            }
            default:
                gap = Constants_portPosEdgeGap;
        }
        const topBottomGap = gap + 0.3;
        let baseOffset$0027;
        let left;
        const side_1 = side;
        let patternInput;
        const sym_2 = sym;
        const comp = sym_2.Component;
        const matchValue = defaultArg(sym_2.HScale, 1);
        const vS = defaultArg(sym_2.VScale, 1);
        const hS = matchValue;
        const matchValue_2 = sym_2.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput = [comp.H * vS, comp.W * hS];
        }
        left = ((side_1.tag === 2) ? (new XYPos(0, 0)) : ((side_1.tag === 0) ? (new XYPos(0, 0)) : ((side_1.tag === 1) ? (new XYPos(0, patternInput[0])) : (new XYPos(patternInput[1], 0)))));
        const right = getMuxSelOffset(sym, side);
        baseOffset$0027 = (new XYPos(left.X + right.X, left.Y + right.Y));
        const portDimension = portsNumber - 1;
        let patternInput_3;
        const sym_3 = sym;
        const comp_1 = sym_3.Component;
        const matchValue_3 = defaultArg(sym_3.HScale, 1);
        const vS_1 = defaultArg(sym_3.VScale, 1);
        const hS_1 = matchValue_3;
        const matchValue_2_1 = sym_3.STransform.Rotation;
        switch (matchValue_2_1.tag) {
            case 1:
            case 3: {
                patternInput_3 = [comp_1.W * hS_1, comp_1.H * vS_1];
                break;
            }
            default:
                patternInput_3 = [comp_1.H * vS_1, comp_1.W * hS_1];
        }
        const w_1 = patternInput_3[1];
        const h_1 = patternInput_3[0];
        switch (side.tag) {
            case 3: {
                const left_2 = baseOffset$0027;
                const right_2 = new XYPos(0, (h_1 * ((portDimension - index) + gap)) / (portDimension + (2 * gap)));
                return new XYPos(left_2.X + right_2.X, left_2.Y + right_2.Y);
            }
            case 1: {
                const left_3 = baseOffset$0027;
                const right_3 = new XYPos((w_1 * (index + topBottomGap)) / (portDimension + (2 * topBottomGap)), 0);
                return new XYPos(left_3.X + right_3.X, left_3.Y + right_3.Y);
            }
            case 0: {
                const left_4 = baseOffset$0027;
                const right_4 = new XYPos((w_1 * ((portDimension - index) + topBottomGap)) / (portDimension + (2 * topBottomGap)), 0);
                return new XYPos(left_4.X + right_4.X, left_4.Y + right_4.Y);
            }
            default: {
                const left_1 = baseOffset$0027;
                const right_1 = new XYPos(0, (h_1 * (index + gap)) / (portDimension + (2 * gap)));
                return new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y);
            }
        }
    };
    const port_2 = FSharpMap__get_Item(model.Ports, portId);
    const symId_1 = port_2.HostId;
    const oldSymbol_1 = FSharpMap__get_Item(model.Symbols, symId_1);
    if (oldSymbol_1.Component.Type.tag === 26) {
        const port_1 = port_2;
        const symId = symId_1;
        const oldSymbol = oldSymbol_1;
        const matchValue_10 = getCloseByEdge(oldSymbol, pos);
        if (matchValue_10 != null) {
            const target = (port = port_1, (symbol_2 = oldSymbol, (tempSymbol = updatePortPos(symbol_2, pos, port.Id), (oldEdge = FSharpMap__get_Item(symbol_2.PortMaps.Orientation, port.Id), (oldOrder = (findIndex((elem) => equals(elem, port.Id), FSharpMap__get_Item(symbol_2.PortMaps.Order, oldEdge)) | 0), (newEdge = FSharpMap__get_Item(tempSymbol.PortMaps.Orientation, port.Id), (newOrder = (findIndex((elem_1) => equals(elem_1, port.Id), FSharpMap__get_Item(tempSymbol.PortMaps.Order, newEdge)) | 0), (newPortPos = getPortPos(tempSymbol, port), (x = ((newEdge.tag === 3) ? ((sym_7 = symbol_2, (comp_5 = sym_7.Component, (matchValue_8 = defaultArg(sym_7.HScale, 1), (vS_5 = defaultArg(sym_7.VScale, 1), (hS_5 = matchValue_8, (matchValue_2_5 = sym_7.STransform.Rotation, (matchValue_2_5.tag === 2) ? [comp_5.H * vS_5, comp_5.W * hS_5] : ((matchValue_2_5.tag === 1) ? [comp_5.W * hS_5, comp_5.H * vS_5] : ((matchValue_2_5.tag === 3) ? [comp_5.W * hS_5, comp_5.H * vS_5] : [comp_5.H * vS_5, comp_5.W * hS_5])))))))))[1] : newPortPos.X), (y = ((newEdge.tag === 1) ? ((sym_8 = symbol_2, (comp_6 = sym_8.Component, (matchValue_9 = defaultArg(sym_8.HScale, 1), (vS_6 = defaultArg(sym_8.VScale, 1), (hS_6 = matchValue_9, (matchValue_2_6 = sym_8.STransform.Rotation, (matchValue_2_6.tag === 2) ? [comp_6.H * vS_6, comp_6.W * hS_6] : ((matchValue_2_6.tag === 1) ? [comp_6.W * hS_6, comp_6.H * vS_6] : ((matchValue_2_6.tag === 3) ? [comp_6.W * hS_6, comp_6.H * vS_6] : [comp_6.H * vS_6, comp_6.W * hS_6])))))))))[0] : newPortPos.Y), equals(newEdge, oldEdge) ? ((diff = ((symbol = symbol_2, (edge = newEdge, (portsOnEdge = (length(FSharpMap__get_Item(symbol.PortMaps.Order, edge)) | 0), (portsOnEdge === 1) ? 0 : ((portsOnEdge === 2) ? ((edge.tag === 0) ? (-getPortPosWithIndex(symbol, 2, edge, 1).X / 2) : ((edge.tag === 2) ? (getPortPosWithIndex(symbol, 2, edge, 0).Y / 2) : ((edge.tag === 3) ? (-getPortPosWithIndex(symbol, 2, edge, 1).Y / 2) : (getPortPosWithIndex(symbol, 2, edge, 0).X / 2)))) : ((portsOnEdge > 2) ? ((edge.tag === 1) ? ((getPortPosWithIndex(symbol, portsOnEdge, edge, 1).X - getPortPosWithIndex(symbol, portsOnEdge, edge, 0).X) / 2) : ((edge.tag === 0) ? ((getPortPosWithIndex(symbol, portsOnEdge, edge, 1).X - getPortPosWithIndex(symbol, portsOnEdge, edge, 0).X) / 2) : ((getPortPosWithIndex(symbol, portsOnEdge, edge, 1).Y - getPortPosWithIndex(symbol, portsOnEdge, edge, 0).Y) / 2))) : 0)))))), (equals(newEdge, Edge.Top) ? true : equals(newEdge, Edge.Bottom)) ? ((oldOrder < newOrder) ? [new XYPos(x + diff, y), pos] : ((oldOrder === newOrder) ? [new XYPos(x, y), pos] : [new XYPos(x - diff, y), pos])) : ((oldOrder < newOrder) ? [new XYPos(x, y + diff), pos] : ((oldOrder === newOrder) ? [new XYPos(x, y), pos] : [new XYPos(x, y - diff), pos])))) : ((offset = ((symbol_1 = symbol_2, (edge_1 = newEdge, (order = (newOrder | 0), (portsOnEdge_1 = (length(FSharpMap__get_Item(symbol_1.PortMaps.Order, edge_1)) | 0), (portsOnEdge_1 === 0) ? ((edge_1.tag === 0) ? (((sym_4 = symbol_1, (comp_2 = sym_4.Component, (matchValue_4 = defaultArg(sym_4.HScale, 1), (vS_2 = defaultArg(sym_4.VScale, 1), (hS_2 = matchValue_4, (matchValue_2_2 = sym_4.STransform.Rotation, (matchValue_2_2.tag === 2) ? [comp_2.H * vS_2, comp_2.W * hS_2] : ((matchValue_2_2.tag === 1) ? [comp_2.W * hS_2, comp_2.H * vS_2] : ((matchValue_2_2.tag === 3) ? [comp_2.W * hS_2, comp_2.H * vS_2] : [comp_2.H * vS_2, comp_2.W * hS_2])))))))))[1] / 2) : ((edge_1.tag === 1) ? (((sym_4 = symbol_1, (comp_2 = sym_4.Component, (matchValue_4 = defaultArg(sym_4.HScale, 1), (vS_2 = defaultArg(sym_4.VScale, 1), (hS_2 = matchValue_4, (matchValue_2_2 = sym_4.STransform.Rotation, (matchValue_2_2.tag === 2) ? [comp_2.H * vS_2, comp_2.W * hS_2] : ((matchValue_2_2.tag === 1) ? [comp_2.W * hS_2, comp_2.H * vS_2] : ((matchValue_2_2.tag === 3) ? [comp_2.W * hS_2, comp_2.H * vS_2] : [comp_2.H * vS_2, comp_2.W * hS_2])))))))))[1] / 2) : (((sym_5 = symbol_1, (comp_3 = sym_5.Component, (matchValue_5 = defaultArg(sym_5.HScale, 1), (vS_3 = defaultArg(sym_5.VScale, 1), (hS_3 = matchValue_5, (matchValue_2_3 = sym_5.STransform.Rotation, (matchValue_2_3.tag === 2) ? [comp_3.H * vS_3, comp_3.W * hS_3] : ((matchValue_2_3.tag === 1) ? [comp_3.W * hS_3, comp_3.H * vS_3] : ((matchValue_2_3.tag === 3) ? [comp_3.W * hS_3, comp_3.H * vS_3] : [comp_3.H * vS_3, comp_3.W * hS_3])))))))))[0] / 2))) : (((portsOnEdge_1 >= 1) && ((order === 0) ? true : (order === portsOnEdge_1))) ? ((patternInput_7 = ((sym_6 = symbol_1, (comp_4 = sym_6.Component, (matchValue_6 = defaultArg(sym_6.HScale, 1), (vS_4 = defaultArg(sym_6.VScale, 1), (hS_4 = matchValue_6, (matchValue_2_4 = sym_6.STransform.Rotation, (matchValue_2_4.tag === 2) ? [comp_4.H * vS_4, comp_4.W * hS_4] : ((matchValue_2_4.tag === 1) ? [comp_4.W * hS_4, comp_4.H * vS_4] : ((matchValue_2_4.tag === 3) ? [comp_4.W * hS_4, comp_4.H * vS_4] : [comp_4.H * vS_4, comp_4.W * hS_4]))))))))), (firstPortPos = getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, 0), (lastPortPos = getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, portsOnEdge_1 - 1), (firstPortXorY = ((edge_1.tag === 0) ? firstPortPos.X : ((edge_1.tag === 1) ? firstPortPos.X : firstPortPos.Y)), (lastPortXorY = ((edge_1.tag === 0) ? lastPortPos.X : ((edge_1.tag === 1) ? lastPortPos.X : lastPortPos.Y)), (hORw = ((edge_1.tag === 0) ? patternInput_7[1] : ((edge_1.tag === 1) ? patternInput_7[1] : patternInput_7[0])), (order === 0) ? ((edge_1.tag === 1) ? ((firstPortXorY / 2) - 2.5) : ((edge_1.tag === 2) ? ((firstPortXorY / 2) - 2.5) : (((hORw + firstPortXorY) / 2) + 2.5))) : ((edge_1.tag === 1) ? (((hORw + lastPortXorY) / 2) + 2.5) : ((edge_1.tag === 2) ? (((hORw + lastPortXorY) / 2) + 2.5) : ((lastPortXorY / 2) - 2.5)))))))))) : ((edge_1.tag === 0) ? ((getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order - 1).X + getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order).X) / 2) : ((edge_1.tag === 1) ? ((getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order - 1).X + getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order).X) / 2) : ((getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order - 1).Y + getPortPosWithIndex(symbol_1, portsOnEdge_1, edge_1, order).Y) / 2))))))))), (equals(newEdge, Edge.Top) ? true : equals(newEdge, Edge.Bottom)) ? [new XYPos(offset, y), pos] : [new XYPos(x, offset), pos]))))))))))));
            const newSymbol_1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(new DrawModelType_SymbolT_ShowPorts(/* ShowOneTouching */ 5, [port_1]))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_movingPortTarget_)(target)(((value_4 = {
                CurrPos: pos,
                PortId: portId,
            }, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_movingPort_)(value_4)))(oldSymbol)));
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(symId))(newSymbol_1)(model), Cmd_none()];
        }
        else {
            const newSymbol = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showPorts_)(DrawModelType_SymbolT_appearance_))(new DrawModelType_SymbolT_ShowPorts(/* ShowOneNotTouching */ 6, [port_1]))(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_movingPortTarget_)(undefined)(((value = {
                CurrPos: pos,
                PortId: portId,
            }, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_movingPort_)(value)))(oldSymbol)));
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(symId))(newSymbol)(model), Cmd_none()];
        }
    }
    else {
        return [model, Cmd_none()];
    }
}

